module.exports = __webpack_public_path__ + "img/carrocerias.ee8ea8a5.jpg";